var p = Object.defineProperty;
var r = (n, e, t) => e in n ? p(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var i = (n, e, t) => r(n, typeof e != "symbol" ? e + "" : e, t);
import { HttpClient as a, httpClient as s } from "../../httpClient.js";
class c extends a {
  constructor() {
    super(...arguments);
    i(this, "endpoint", "/lessons");
  }
  async getOne(t) {
    return s.get(`${this.endpoint}/${t}`);
  }
  async update(t, o) {
    return s.put(`${this.endpoint}/${t}`, o);
  }
  async getObjectives(t) {
    return s.get(`${this.endpoint}/${t}/objectives`);
  }
}
const u = new c();
export {
  u as default
};
